import { lazy } from 'react';
import { summarizeHandler, continueWritingHandler, makeShorterHandler, makeLongerHandler } from 'redux/toolbar';

export const autocompleteModes = [
  {
    key: 'inline',
    icon: 'lizzy-autocomplete-inline',
    label: 'Inline Autocomplete'
  },
  {
    key: 'dropdown',
    icon: 'lizzy-autocomplete-dropdown',
    label: 'Autocomplete Dropdown'
  },
  {
    key: 'off',
    icon: 'lizzy-autocomplete-off',
    label: 'Autocomplete Off'
  },
];

export const toolbarOptions = [
  [
    {
      key: 'autocomplete',
      icon: 'lizzy-autocomplete',
      modes: autocompleteModes,
      tooltip: '{currrentModeTooltip}',
      excludeOutsideClickId: 'autocomplete'
    }
  ],
  [
    {
      key: 'summarize',
      icon: 'lizzy-summarize',
      expandToolbar: true,
      selectParagraph: true,
      hasState: true,
      tooltip: 'Summarize',
      action: summarizeHandler,
    },
    {
      key: 'continue-writing',
      icon: 'lizzy-continue-writing',
      expandToolbar: true,
      selectParagraph: true,
      hasState: true,
      tooltip: 'Continue Writing',
      action: continueWritingHandler
    },
    {
      key: 'provistion-definition',
      icon: 'lizzy-definition',
      expandToolbar: true,
      selectSentence: true,
      hasState: true,
      tooltip: 'Provision/Definition',
      component: lazy(() => import('components/ToolbarProvision')),
    },
    {
      key: 'shorter',
      icon: 'lizzy-shorten',
      expandToolbar: true,
      tooltip: 'Shorter',
      action: makeShorterHandler
    },
    {
      key: 'longer',
      icon: 'lizzy-longer',
      expandToolbar: true,
      tooltip: 'Longer',
      action: makeLongerHandler
    },
    {
      key: 'contract-overview',
      icon: 'lizzy-contract-overview',
      expandToolbar: true,
      tooltip: 'Contract Overview',
      hasState: true,
      component: lazy(() => import('components/ToolbarContractOverview')),
    },
  ],
  [
    {
      key: 'more',
      icon: 'lizzy-more-vertical',
      dropdownMenu: [
        [
          {
            key: 'rephrase',
            icon: 'material-refresh',
            label: 'Rephrase',
            description: 'Cmd+Shift+R'
          },
          {
            key: 'simplify_lang',
            icon: 'material-text_fields',
            label: 'Simplify language',
            description: 'Shortcut'
          },
          {
            key: 'explain',
            icon: 'material-info',
            label: 'Explain this',
          },
          {
            key: 'contract_overview',
            icon: 'material-list',
            label: 'Contract Overview',
          },
          {
            key: 'key_issues',
            icon: 'material-flag',
            label: 'List key issues',
          }
        ],
        [
          {
            key: 'feedback',
            icon: 'material-notifications',
            label: 'Feedback',
          },
          {
            key: 'settings',
            icon: 'material-settings',
            label: 'Settings',
          }
        ],
        [
          {
            key: 'logout',
            icon: 'material-logout',
            label: 'Log Out',
          }
        ]
      ],
    },
  ]
];

export const getOptionByKey = (optionKey) => {
  return toolbarOptions.flat().find((option) => option.key === optionKey);
}